<template>
  <div class="group_offers">
    <div class="group_offer" :class="{[group_offer.status]:true}" v-for="group_offer in data.group_offers">
        <div class="subtitle">New Group Offer</div>
      <label>
        Schedule: 
        <div>
          {{ group_offer.group.schedule }}
        </div>
      </label>

      <label>
        Duration: 
        <div>
          {{ group_offer.group.duration }}
        </div>
      </label>
      
      
      <label>
        Students: 
        <div>
            <template v-for="student in group_offer.group.student">
                {{ student.ui }} - {{ student.level }}<br>
            </template>
        </div>
      </label>

      <label>
        Status: 
        <div>
            {{ group_offer.status }}
        </div>
      </label>

      <button @click.stop="respond_group_offer(group_offer,'accepted')">Accept</button>
      <button @click.stop="respond_group_offer(group_offer,'rejected')">Reject</button>

    </div>
  </div>




</template>


<script setup>

import { onMounted,reactive,inject } from 'vue'
import axios from 'axios'

let data=reactive({
    show:true,
    group_offers:{}
})

data=inject('group_offers_data')


async function respond_group_offer(group_offer,answer){
    console.log(group_offer,answer)
    let response=await axios.post('/instructors/respond_group_offer/',{group_offer_id:group_offer.id,answer:answer})
    Object.assign(group_offer,response.data)
}





</script>



<style scoped>
 .group_offers{

    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width:100%;
    height: auto;
    padding: 6px;
    gap:8px;
    background: var(--gray);
 }

  .group_offer{
    background: var(--lightgray);
    border:var(--border);
    border-radius: 6px;
    padding:4px;
    width: fit-content;
    height: auto;


  }

  label{
    display: flex;
    
  }


  .accepted{
    background: var(--green);

  }

  .rejected{
    background: var(--red);
  }


</style>